import React, { useEffect, useState } from 'react'
import { Modal } from 'web/src/app/root/components/common'
import Loader from 'web/src/app/root/components/common/loader'
import { Box } from '@material-ui/core'
import { ImageUpload } from './image-upload'
import { useStyles } from './styles'
import { useSelector } from 'react-redux'
import Button from 'web/src/app/root/components/common/button'

export const ImagesUploadModal = ({
    isModalOpen,
    setIsModalOpen,
    imagesForUpload,
    setImagesForUpload,
    deletedPictureKeys,
    setDeletedPictureKeys,
    isEdit,
    submitUploadImages,
    getImagesByDeviceId
}) => {
    const { theme, locale } = useSelector(state => state.main)
    const classes = useStyles(theme)
    const { deviceImagesLoader } = useSelector(state => state.devices)
    const [disableRefetchImages, setDisableRefetchImages] = useState(false)

    useEffect(() => {
        if (!deviceImagesLoader) {
            setIsModalOpen(false)
        }
    }, [deviceImagesLoader])

    useEffect(() => {
        if (!isModalOpen && !disableRefetchImages) {
            setDeletedPictureKeys([])
            getImagesByDeviceId()
        }
        setDisableRefetchImages(false)
    }, [isModalOpen])

    return (
        <Box>
            <Modal
                open={isModalOpen}
                setOpen={() => {
                    !deviceImagesLoader && setIsModalOpen(false)
                }}>
                <Box className={classes.container}>
                    {imagesForUpload?.map((item, index) => {
                        return (
                            <ImageUpload
                                key={index}
                                imagesForUpload={imagesForUpload}
                                setImagesForUpload={setImagesForUpload}
                                setDeletedPictureKeys={setDeletedPictureKeys}
                                deletedPictureKeys={deletedPictureKeys}
                                data={item}
                                indexOfCommentCard={index}
                                isEdit={isEdit}
                            />
                        )
                    })}

                    {imagesForUpload?.length < 5 && !deviceImagesLoader && (
                        <ImageUpload
                            imagesForUpload={imagesForUpload}
                            setImagesForUpload={setImagesForUpload}
                        />
                    )}
                </Box>
                <Box className={classes.buttonsWrapper}>
                    {!deviceImagesLoader ? (
                        <>
                            <Button
                                className={classes.saveButton}
                                onClick={() => {
                                    submitUploadImages()
                                    setDisableRefetchImages(true)
                                }}>
                                {locale.common.save}
                            </Button>
                            <Button
                                reverted
                                style={{ marginLeft: '10px' }}
                                sign
                                className={classes.saveButton}
                                onClick={() => {
                                    setIsModalOpen(false)
                                }}>
                                {locale.common.cancel}
                            </Button>
                        </>
                    ) : (
                        <Loader />
                    )}
                </Box>
            </Modal>
        </Box>
    )
}
